import React from "react";
import { useFormContext } from "react-hook-form";
import cn from "classnames";
import Button, { Size, Variant } from "storefront/components/Button";
import styles from "./FormSubmit.module.scss";

interface FormSubmitProps {
  children: React.ReactNode;
  className?: string;
  /** ID of the form to submit (when the button is outside the form) */
  form?: string;
  disabled?: boolean;
  variant?: Variant;
  size?: Size;
}

/**
 * FormSubmit component
 *
 * A submit button for forms.
 */
const FormSubmit: React.FC<FormSubmitProps> = ({
  children,
  className,
  form,
  disabled,
  variant = "primary",
  size = "large",
}) => {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <Button
      className={cn(styles.formSubmit, className)}
      disabled={disabled || isSubmitting}
      form={form}
      size={size}
      type="submit"
      variant={variant}
    >
      {children}
    </Button>
  );
};

export default FormSubmit;
